/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is a 15-minute break long enough to be useful?`)
};

const es_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es una pausa de 15 minutos lo bastante larga para ser útil?`)
};

const de_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist eine 15-minütige Pause lang genug, um etwas zu bringen?`)
};

const nl_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is een pauze van 15 minuten lang genoeg om nuttig te zijn?`)
};

const fr_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une pause de 15 minutes est-elle assez longue pour être utile ?`)
};

const it_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una pausa di 15 minuti è abbastanza lunga da essere utile?`)
};

const pt_br2_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma pausa de 15 minutos é longa o suficiente para ser útil?`)
};

const pt_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma pausa de 15 minutos é suficientemente longa para ser útil?`)
};

const ja_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15分の休憩は効果があるのに十分な長さですか？`)
};

const zh_timer_u15m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15分钟的休息足够有效吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u15m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u15m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u15m_faq3_q", locale)
	if (locale === "en") return en_timer_u15m_faq3_q(inputs)
	if (locale === "es") return es_timer_u15m_faq3_q(inputs)
	if (locale === "de") return de_timer_u15m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u15m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u15m_faq3_q(inputs)
	if (locale === "it") return it_timer_u15m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u15m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u15m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u15m_faq3_q(inputs)
	return zh_timer_u15m_faq3_q(inputs)
};